import { MetricConfig } from './tvd-types';

export const TvdNavbarMetricsConfig: MetricConfig[] = [
    {
        metricName: "Operational Performance",
        metricSubHeader: "Productivity",
        metrics: [
            {
                id:'hospitality',
                title: "Hospitality",
                isHidden: false,
                isIncludePayload:true
            },
            {
                id:'foodservice',
                title: "Full Service Restaurants",
                isHidden: false,
                isIncludePayload:true
            }
        ]
    },
    {
        metricName: "Environmental Impact",
        metricSubHeader: "",
        metrics: [
            {
                id:'energy',
                title: "Energy",
                isHidden: false,
                isIncludePayload:false
            },
            {
                id:'water',
                title: "Water",
                isHidden: false,
                isIncludePayload:false
            }
        ]
    }
];
